import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'src/app/globals';
import { CoursesService } from '../../../service/courses.service';
import { ToastrService } from 'ngx-toastr';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ScheduleService } from 'src/app/service/schedule.service';
declare var $: any;

@Component({
  selector: 'app-schedule-setup',
  templateUrl: './schedule-setup.component.html',
  styleUrls: ['./schedule-setup.component.scss']
})
export class ScheduleSetupComponent implements OnInit {
  showLoader: boolean = false;
  schedules: any;

  constructor(private toastrService: ToastrService, public coursesService: CoursesService, public globals: Globals, private router: Router
    , public translate: TranslateService, private scheduleService: ScheduleService) { }

  ngOnInit(): void {
    this.showLoader=true;
    this.getSchedules();
    // this.schedules = [
    //   {
    //     id: "1",
    //     effectiveDateFrom: "2022-01-30",
    //     effectiveDateTo: "2022-02-25",
    //     timeSlot: "30",
    //     breakTimeSclot: "15",
    //     sun: "10",
    //     mon: "11",
    //     tue: "12",
    //     web: "13",
    //     thu: "14",
    //     fri: "15",
    //     sat: "16",
    //     weekStarts: "MON",
    //     active: "NO",
    //   },
    //   {
    //     id: "2",
    //     effectiveDateFrom: "2022-02-26",
    //     effectiveDateTo: "",
    //     timeSlot: "60",
    //     breakTimeSclot: "25",
    //     sun: "20",
    //     mon: "30",
    //     tue: "40",
    //     web: "50",
    //     thu: "60",
    //     fri: "70",
    //     sat: "80",
    //     weekStarts: "SUN",
    //     active: "YES",
    //   },
    // ];
    // this.updateTable();
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.updateTable();
    });
    this.showLoader=false;
  }

  updateTable() {
    $("#datatable").DataTable().destroy();
    setTimeout(() => {
      $("#datatable").DataTable({
        dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        // responsive: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        // "columnDefs": [
        //   { "orderable": false, "targets": [1, 2] }
        // ],
        pageLength: 5,
        lengthChange: false,
        info: true,
        search: {
          searchPlaceholder: "Search",
        },
        paging: true,
        language: {
          search: "",
          searchPlaceholder: "Search",
        },
        buttons: [{
          extend: 'csvHtml5',
          text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
          titleAttr: 'CSV',
          exportOptions: {
            // columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
            columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
          }
        }],
      });
    }, 1);
  }

  editSchedule(id: any) {
    this.router.navigate(
      ['/schedule/schedule-setup-update'],
      { queryParams: { scheduleId: id } });
  }

  getSchedules() {
    this.showLoader = true;
    this.scheduleService.getSchedules().subscribe(
      data => {
        this.schedules = data;
      },
      error => {
        this.updateTable();
        this.toastrService.error(this.translate.instant("CAN_NOT_GET_SCHEDULES"));
        this.showLoader = false;
      },
      () => {
        this.showLoader = false;
        this.updateTable();
      }
    );
  }
}


